import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';

import { CDSMask } from '@app/utils/cds-mask';
import { ToastrService } from 'ngx-toastr';

import { RelatorioService } from '@app/services/relatorio.service';
import { IdDescricao } from '@app/models/util/id-descricao';
import { ConsultasService } from '@app/services/consultas.service';
import { Filtros } from './filtros';
import { UtilitarioService } from '@app/services/utilitario.service';


@Component({
  selector: 'app-rellogs',
  templateUrl: 'logs.component.html',
  styleUrls: ['./logs.component.scss']
})
export class RelatorioLogsComponent implements OnInit {

  lstUnidades: IdDescricao[] = [];
  lstParticipante: Array<any> = [{}];
  filtros: Filtros = new Filtros();

  rel: any[];
  pesquisando: boolean;
  showTable: boolean;

  dataRelatorio: Date;

  constructor(
    private relatorioService: RelatorioService,
    private consultasService: ConsultasService,
    @Inject(ToastrService) public toastr: ToastrService
  ) { }
  ngOnInit() {
    this.consultasService.consultar('UNIDADE_S_RATEIO').toPromise().then(data => this.lstUnidades = data);
    this.consultasService.consultar('USUARIO').toPromise().then(data => this.lstParticipante = data);
  }

  pesquisar() {
    this.dataRelatorio = new Date();
    this.pesquisando = true;
    this.relatorioService.logs(this.filtros).toPromise()
      .then(data => {
        this.rel = data;
        this.pesquisando = false;

        if (this.rel.length == 0) {
          this.toastr.info("Busca não encontrou resultados");
          this.showTable = false;
        } else {
          this.showTable = true;
        }
      }, erro => {
        this.pesquisando = false
        this.toastr.warning("Realize a pesquisa novamente.")
      });
    //  () => this.pesquisando = false);
  }

  @ViewChild('relatorio') relatorio: ElementRef;
  public imprimir() {
    let conteudo = document.getElementById("relatorioDeLogs").innerHTML;
    UtilitarioService.imprimirHTML(conteudo, "Relatorio de Logs", this.montaImpressaoFiltros());
  }

  private montaImpressaoFiltros(){
    let objetoFiltros = new Map<string, string>();

    adicionaMapValido('Emitido em', this.dataRelatorio.toLocaleString());
    
    parseDateAdicionaMap('Data Inicial', this.filtros.DataInicial);
    parseDateAdicionaMap('Data Final', this.filtros.DataFinal);
    
    obtemDescricaoAdicionaMap('Unidade', this.lstUnidades, this.filtros.UnidadeId);
    obtemDescricaoAdicionaMap('Funcionário', this.lstParticipante, this.filtros.ParticipanteId);

    function obtemDescricaoAdicionaMap(chave: string, listaItens: IdDescricao[], idItem: number){
      if(idItem){
        let valor = listaItens.find(x => x.Id === idItem).Descricao;
        objetoFiltros.set(chave, valor);
      } 
    }

    function parseDateAdicionaMap(tipoData: string, data: string){
      if(data && data.indexOf('-') >= 0){
        let dataPartes = data.split('-');
        let dataMontada = dataPartes[2] + '/' + dataPartes[1] + '/' + dataPartes[0];
        objetoFiltros.set(tipoData, dataMontada);
      }
    }

    function adicionaMapValido(chave: string, valor: any){
      if(valor){
        objetoFiltros.set(chave, valor.toString());
      }
    }

    let stringHtml = '';

    objetoFiltros.forEach((valor, chave) => {
      stringHtml += `<tr><td>${chave}</td><td>${valor}</td></tr>`;
    })
    return stringHtml;
  }

}

